<!--
 * @Author: ningbo.kang
 * @Date: 2020-08-06 11:48:56
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-12-28 13:34:35
 * @Description: 描述
-->
<template>
    <div class="switch-table-layout" v-if="!tableScroll">
        <span
            class="switch-item"
            :title="t('wg.table.tableTip')"
            :class="tbClass"
            @click="handleClick('table')"
        >
            <i class="switch-icon"></i>{{ t("wg.table.table") }}
        </span>
        <a-divider type="vertical" />
        <span
            class="switch-item"
            :title="t('wg.table.panleTip')"
            :class="panelClass"
            @click="handleClick('panel')"
        >
            <i class="switch-icon"></i>{{ t("wg.table.panel") }}
        </span>
    </div>
</template>
<script>
import { t } from "../../locale";
import baseMixin from "../../lib/baseMixin";

export default {
    mixins: [baseMixin],
    data() {
        return {
            layoutName: "table",
            tableScroll: false,
        };
    },
    computed: {
        tbClass() {
            if (this.layoutName === "table") {
                return "tb-select";
            }
            return "tb-unselect";
        },
        panelClass() {
            if (this.layoutName === "panel") {
                return "panel-select";
            }
            return "panel-unselect";
        },
    },
    mounted() {
        // 获取路由参数
        const { defKey } = this.$route.query;
        // 暂时写死白名单
        const whiteList = this.remote.getWhiteUrlList();
        if (defKey) {
            // 匹配数据 传入进来的数据
            const data = whiteList.find((item) => item === defKey);
            if (data && this.disabled) {
                this.tableScroll = true;
            }
        }
    },
    methods: {
        t(...args) {
            return t.apply(this, args);
        },
        handleClick(val) {
            this.layoutName = val;
            this.$emit("change", val);
        },
    },
};
</script>
